(self["webpackChunkheyholy_ss_theme"] = self["webpackChunkheyholy_ss_theme"] || []).push([["/assets/big-images-slider"],{

/***/ "./src/assets/js/big-images-slider.js":
/*!********************************************!*\
  !*** ./src/assets/js/big-images-slider.js ***!
  \********************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var BigImagesSlider = /*#__PURE__*/function (_HTMLElement) {
  function BigImagesSlider() {
    var _this;
    _classCallCheck(this, BigImagesSlider);
    _this = _callSuper(this, BigImagesSlider);
    _this.slider = _this.querySelector('.big-images-slider__swiper-top');
    _this.slides = _this.querySelectorAll('.big-images-slider__swiper-top .swiper-slide');
    _this.pagination = _this.querySelector('.big-images-slider__pagination');
    _this.arrowPrev = _this.querySelector('.big-images-slider__arrow--prev');
    _this.arrowNext = _this.querySelector('.big-images-slider__arrow--next');
    _this.sectId = _this.dataset.sectid;
    _this.blockData = window['imageSlidesData' + _this.sectId];
    _this.topTextEl = _this.querySelector('.big-images-slider__top-part');
    _this.topTitleEl = _this.querySelector('.big-images-slider__products-title');
    _this.vetTextEl = _this.querySelector('.big-images-slider__vet-text');
    _this.vetImageEl = _this.querySelector('.big-images-slider__vet-image');
    _this.productsLayoutEl = _this.querySelector('.big-images-slider__products-layout');
    _this.viewAllUrlEl = _this.querySelector('.big-iamges-slider__product-url');
    _this.upsellProducts = _this.querySelector('.slide-products__container');
    return _this;
  }
  _inherits(BigImagesSlider, _HTMLElement);
  return _createClass(BigImagesSlider, [{
    key: "initSlider",
    value: function initSlider() {
      var self = this;
      this.activeSlider = new Swiper(this.slider, {
        slidesPerView: 2.3,
        spaceBetween: 16,
        centeredSlides: false,
        draggable: true,
        allowTouchMove: true,
        loop: true,
        loopedSlides: 15,
        preloadSlides: 15,
        pagination: {
          el: this.pagination,
          clickable: false
        },
        breakpoints: {
          768: {
            centeredSlides: true,
            slidesPerView: 4.3,
            spaceBetween: 30
          },
          1024: {
            centeredSlides: true,
            slidesPerView: 6.1,
            spaceBetween: 55
          }
        },
        navigation: {
          nextEl: this.arrowNext,
          prevEl: this.arrowPrev
        },
        on: {
          slideChange: function slideChange(swiper, event) {
            self.updateContent();
          }
        }
      });
    }
  }, {
    key: "onSlideClick",
    value: function onSlideClick() {
      var _this2 = this;
      this.slides.forEach(function (slide, index) {
        slide.addEventListener('click', function () {
          var clickedIndex = index;
          if (clickedIndex !== _this2.activeSlider.realIndex) {
            _this2.activeSlider.slideToLoop(clickedIndex);
            _this2.onScrollToElement();
          }
        });
      });
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this3 = this;
      document.addEventListener('DOMContentLoaded', function () {
        var checkSwiper = setInterval(function () {
          if (typeof Swiper !== 'undefined') {
            _this3.initSlider();
            _this3.updateContent();
            _this3.onSlideClick();
            clearInterval(checkSwiper);
          }
        }, 100);
      });
    }
  }, {
    key: "updateContent",
    value: function updateContent() {
      var _this$activeSlider;
      var activeIndex = (_this$activeSlider = this.activeSlider) !== null && _this$activeSlider !== void 0 && _this$activeSlider.realIndex ? this.activeSlider.realIndex : 0;
      var slideData = this.blockData[activeIndex];
      this.topTextEl.innerHTML = slideData.topText;
      this.topTextEl.classList.add('tw-text-center');
      this.vetImageEl.src = slideData.vetImage;
      this.vetTextEl.innerHTML = slideData.vetText;
      var productsHtml = this.upsellProducts.querySelector(".slide-products-".concat(activeIndex)).innerHTML;
      var productCount = this.upsellProducts.querySelector(".slide-products-".concat(activeIndex)).querySelectorAll(".grid-item").length;
      if (productCount <= 2) {
        this.productsLayoutEl.classList.add('small-grid');
      } else {
        this.productsLayoutEl.classList.remove('small-grid');
      }
      this.productsLayoutEl.innerHTML = productsHtml;
      this.viewAllUrlEl.textContent = slideData.viewAllText;
      this.viewAllUrlEl.setAttribute('href', slideData.viewAllUrl);
    }
  }, {
    key: "onScrollToElement",
    value: function onScrollToElement() {
      var _this4 = this;
      setTimeout(function () {
        var targetElement = _this4.topTitleEl;
        if (targetElement) {
          var isMobile = window.innerWidth < 768;
          var offset = isMobile ? 40 : 100;
          var topPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({
            top: topPosition,
            behavior: 'smooth'
          });
        }
      }, 300);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('big-images-slider__swiper')) {
  customElements.define('big-images-slider__swiper', BigImagesSlider);
}

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/assets/js/big-images-slider.js"));
/******/ }
]);